export class MemberLanguages {
    public Code: string="";
    public Description: string = "";
    public IsAlternateLanguage: boolean;
}